// Library Imports
import styled from "styled-components";
import { Tooltip, Typography } from "antd";

// Local Imports
import Checkbox from "../../../Common/Components/Checkbox";

interface IGroupUserListItemProps {
  userColor?: string;
  userImage?: string;
  userName?: string;
  userEmail?: string;
  userDesignation?: string;
  userPersonality?: string[];
  onClickChecked?: any;
  isChecked?: any;
  company?: any;
}

const GroupUserListItem: React.FC<IGroupUserListItemProps> = (props) => {
  const { Paragraph } = Typography;
  /* Toggle class "active qa-tr-active", "active-new" and "drag-active"  on tr for checked items */
  return (
    <tr className={`table-style ${props.isChecked ? "active-new" : "active"}`} data-id="qa-manage-table-tr">
      <td className="checkbox">
        <Checkbox
          width={"18px"}
          height={"18px"}
          data-id="qa-checkbox-user"
          onChange={props.onClickChecked}
          checked={props.isChecked}
        />
      </td>
      <td>
        <span
          className="profile-img-wrapper"
          style={{
            borderColor: props.userColor ? props.userColor : "#ffffff",
            backgroundColor: props?.userColor ? props.userColor : "#ffffff",
          }}
        >
          <img src={props.userImage} className="profile-img" alt="" />
        </span>
        <div className="profile">
          {/* <div className="hidden-contact-name">{props.userName !== "" ? props.userName : props.userEmail}</div> */}
          <Paragraph
            className="name"
            ellipsis={{
              rows: 1,
              tooltip: props?.userName?.trim() === "" || props.userName === null ? props?.userEmail : props?.userName,
            }}
          >
            {props.userName !== "" ? props.userName : props.userEmail}
          </Paragraph>
          <Paragraph className="email"
            ellipsis={{
              rows: 1,
              tooltip: props.userEmail,
            }}
          >
            {props.userEmail}
          </Paragraph>
          <Paragraph className="designation"
            ellipsis={{
              rows: 1,
              tooltip: props?.userDesignation
            }}
          >
            {props.userDesignation}
          </Paragraph>
        </div>
      </td>
      <td className="company-name">{props.company}</td>
      <td>
        <strong className="personality d-flex align-items-center" data-qa="qa-orgainization-one">
          <Circle color={props.userColor ? props.userColor : "black"} />
          {props.userPersonality ? props.userPersonality : "N/A"}
        </strong>
      </td>
    </tr >
  );
};

export default GroupUserListItem;

const Circle = styled.div<{ color: string }>`
  width: 10px;
  height: 10px;
  background: ${(props) => props.color};
  border-radius: 50%;
  margin-right: 3px;
`;

const EllipsisSpan = styled.span`
  padding: 3px;
  position: relative;
  z-index: 0;
  margin-right: 5px;
  cursor: pointer;
  &.disable {
    pointer-events: none;
    opacity: 0.5;
  }
`;
